// src/components/price-summary/price-summary.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    value\n    state\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment PriceMessageFragment on DisplayPrice {\n    __typename\n    role\n    price {\n      formatted\n      accessibilityLabel\n    }\n    disclaimer {\n      content\n      primaryUIButton {\n        accessibility\n        primary\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment PriceSummaryFragment on PropertyPrice {\n    displayMessages {\n      lineItems {\n        ...PriceMessageFragment\n        ...EnrichedMessageFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import React4 from "react";
import { gql as gql3 } from "@apollo/client";
import { useExperiment } from "@shared-ui/experiment-context";
import { UitkLayoutFlex as UitkLayoutFlex2 } from "uitk-react-layout-flex";
// src/components/price-summary/__private/__fragments/price-summary-enriched-message.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var stateToUitkTextWeight = {
    STRONG: "bold"
};
var EnrichedMessage = function(param) {
    var _param_data = param.data, value = _param_data.value, state = _param_data.state, textAlign = param.textAlign, _param_legalNightlyExperimentVariant = param.legalNightlyExperimentVariant, legalNightlyExperimentVariant = _param_legalNightlyExperimentVariant === void 0 ? 0 : _param_legalNightlyExperimentVariant;
    return /* @__PURE__ */ React.createElement(UitkText, {
        size: legalNightlyExperimentVariant === 2 ? 300 : 200,
        weight: state ? stateToUitkTextWeight[state] : "regular",
        align: textAlign
    }, value);
};
EnrichedMessage.fragment = fragment;
EnrichedMessage.fragment.__typename = "LodgingEnrichedMessage";
EnrichedMessage.displayName = "EnrichedMessage";
// src/components/price-summary/__private/__fragments/price-summary-price-message.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
// src/components/price-summary/__private/price-summary-price-disclaimer.tsx
import React2 from "react";
import { EGDSLocalNeutralColorLink } from "@egds/react-lodging";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
var PriceDisclaimer = function(param) {
    var disclaimer = param.disclaimer, textAlign = param.textAlign, children = param.children, type = param.type, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var _primaryUIButton;
    var content = disclaimer.content, primaryUIButton = disclaimer.primaryUIButton;
    var dialogKey = React2.useMemo(function() {
        return Math.random().toString(36).substr(2, 5);
    }, []);
    var dialogId = "".concat(type, "-price-disclaimer-").concat(dialogKey);
    var _useDialog = _sliced_to_array(useDialog(dialogId), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var trackClick = useClickTracker();
    var handleMoreInfoClick = React2.useCallback(function() {
        dialogActions.openDialog();
    }, [
        dialogActions
    ]);
    var experimentControl = /* @__PURE__ */ React2.createElement(UitkMoreInfoTrigger, {
        onClick: handleMoreInfoClick,
        onClickCapture: function() {
            return trackClick(".Price.DisclaimerDialog", "Price Disclaimer Dialog");
        },
        "data-stid": "disclaimer-dialog-link"
    }, /* @__PURE__ */ React2.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlex, {
        direction: textAlign === "left" ? "row-reverse" : "row"
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React2.createElement(UitkIcon, {
        name: "info_outline",
        size: UitkIconSize.SMALL
    })), /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, null, children))));
    var experimentVariant = /* @__PURE__ */ React2.createElement(EGDSLocalNeutralColorLink, {
        onClick: handleMoreInfoClick,
        onClickCapture: function() {
            return trackClick(".Price.DisclaimerDialog", "Price Disclaimer Dialog");
        },
        "data-stid": "disclaimer-dialog-link",
        inline: true
    }, /* @__PURE__ */ React2.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlex, {
        direction: textAlign === "left" ? "row-reverse" : "row"
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, null, children))));
    var _primaryUIButton_primary;
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, enableInlineLink ? /* @__PURE__ */ React2.createElement(Experiment, {
        name: "EGDS_remove_info_icon_and_add_inline_link"
    }, /* @__PURE__ */ React2.createElement(ExperimentControl, null, experimentControl), /* @__PURE__ */ React2.createElement(ExperimentVariant, {
        bucket: 1
    }, experimentVariant)) : experimentControl, /* @__PURE__ */ React2.createElement(DialogComponent, null, /* @__PURE__ */ React2.createElement(UitkDialog, {
        returnFocusOnClose: true,
        dialogShow: isDialogOpen
    }, /* @__PURE__ */ React2.createElement(UitkDialogContent, null, content, /* @__PURE__ */ React2.createElement(UitkDialogFooter, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: (_primaryUIButton_primary = (_primaryUIButton = primaryUIButton) === null || _primaryUIButton === void 0 ? void 0 : _primaryUIButton.primary) !== null && _primaryUIButton_primary !== void 0 ? _primaryUIButton_primary : "",
            type: "tertiary"
        }
    })))));
};
// src/components/price-summary/__private/__fragments/price-summary-price-message.tsx
var fragment2 = gql2(_templateObject1());
var FallbackPrice = function(param) {
    var _param_price = param.price, formatted = _param_price.formatted, accessibilityLabel = _param_price.accessibilityLabel;
    return /* @__PURE__ */ React3.createElement(UitkSpacing, null, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, accessibilityLabel || formatted), /* @__PURE__ */ React3.createElement("span", {
        "aria-hidden": "true"
    }, /* @__PURE__ */ React3.createElement(UitkText2, null, formatted))));
};
var LeadPrice = function(param) {
    var _param_price = param.price, formatted = _param_price.formatted, accessibilityLabel = _param_price.accessibilityLabel;
    return /* @__PURE__ */ React3.createElement(UitkSpacing, {
        padding: {
            block: "half"
        }
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, accessibilityLabel || formatted), /* @__PURE__ */ React3.createElement("span", {
        "aria-hidden": "true"
    }, /* @__PURE__ */ React3.createElement(UitkText2, {
        size: 500,
        weight: "medium",
        theme: "emphasis"
    }, formatted))));
};
var StrikeOutPrice = function(param) {
    var _param_price = param.price, formatted = _param_price.formatted, accessibilityLabel = _param_price.accessibilityLabel, disclaimer = param.disclaimer, textAlign = param.textAlign, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var strikeOutText = /* @__PURE__ */ React3.createElement(UitkSpacing, {
        padding: {
            inline: "half"
        }
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement("del", null, /* @__PURE__ */ React3.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, accessibilityLabel || formatted), /* @__PURE__ */ React3.createElement("span", {
        "aria-hidden": "true"
    }, /* @__PURE__ */ React3.createElement(UitkText2, {
        size: 300
    }, formatted)))));
    if (disclaimer) {
        return /* @__PURE__ */ React3.createElement(PriceDisclaimer, {
            disclaimer: disclaimer,
            textAlign: textAlign,
            type: "STRIKEOUT",
            enableInlineLink: enableInlineLink
        }, strikeOutText);
    }
    return strikeOutText;
};
var InformativePrice = function(param) {
    var _param_price = param.price, formatted = _param_price.formatted, accessibilityLabel = _param_price.accessibilityLabel, disclaimer = param.disclaimer, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var informativeText = /* @__PURE__ */ React3.createElement(UitkSpacing, {
        padding: {
            inline: "half"
        }
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, accessibilityLabel || formatted), /* @__PURE__ */ React3.createElement("span", {
        "aria-hidden": "true"
    }, /* @__PURE__ */ React3.createElement(UitkText2, {
        size: 200
    }, formatted))));
    if (disclaimer) {
        return /* @__PURE__ */ React3.createElement(PriceDisclaimer, {
            disclaimer: disclaimer,
            textAlign: "left",
            type: "INFORMATIVE",
            enableInlineLink: enableInlineLink
        }, informativeText);
    }
    return informativeText;
};
var PriceMessage = function(param) {
    var data = param.data, textAlign = param.textAlign, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var role = data.role;
    switch(role){
        case "LEAD":
            return /* @__PURE__ */ React3.createElement(LeadPrice, _object_spread({}, data));
        case "STRIKEOUT":
            return /* @__PURE__ */ React3.createElement(StrikeOutPrice, _object_spread_props(_object_spread({}, data), {
                textAlign: textAlign,
                enableInlineLink: enableInlineLink
            }));
        case "INFORMATIVE":
            return /* @__PURE__ */ React3.createElement(InformativePrice, _object_spread_props(_object_spread({}, data), {
                enableInlineLink: enableInlineLink
            }));
        default:
            return /* @__PURE__ */ React3.createElement(FallbackPrice, _object_spread({}, data));
    }
};
PriceMessage.fragment = fragment2;
PriceMessage.fragment.__typename = "DisplayPrice";
PriceMessage.displayName = "PriceMessage";
StrikeOutPrice.displayName = "StrikeOutPrice";
LeadPrice.displayName = "LeadPrice";
FallbackPrice.displayName = "FallbackPrice";
// src/components/price-summary/price-summary.tsx
var fragment3 = gql3(_templateObject2(), PriceMessage.fragment, EnrichedMessage.fragment);
var validLinesItems = [
    PriceMessage,
    EnrichedMessage
];
var MessageLine = function(param) {
    var flexAlignment = param.flexAlignment, index = param.index, displayMessage = param.displayMessage, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var _displayMessage_lineItems, _displayMessage;
    var _useExperiment = useExperiment("legal_test_nightly_POSa_total_lead_price_"), legalNightlyExperimentVariant = _useExperiment.exposure;
    return /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, {
        space: "one",
        justifyContent: flexAlignment,
        direction: "row",
        alignItems: "center",
        wrap: "wrap",
        dataTestId: "price-summary-message-line"
    }, (_displayMessage = displayMessage) === null || _displayMessage === void 0 ? void 0 : (_displayMessage_lineItems = _displayMessage.lineItems) === null || _displayMessage_lineItems === void 0 ? void 0 : _displayMessage_lineItems.map(function(lineItem, lineItemIndex) {
        var __typename = (lineItem || {}).__typename;
        var LineItem = validLinesItems.find(function(component) {
            return component.fragment.__typename === __typename;
        });
        if (!LineItem) {
            return null;
        }
        return /* @__PURE__ */ React4.createElement(LineItem, {
            key: "attr-".concat(index, "-").concat(lineItemIndex),
            data: lineItem,
            textAlign: flexAlignment === "end" ? "right" : "left",
            enableInlineLink: enableInlineLink,
            legalNightlyExperimentVariant: legalNightlyExperimentVariant.bucket
        });
    }));
};
var PriceSummary = function(param) {
    var data = param.data, _param_flexAlignment = param.flexAlignment, flexAlignment = _param_flexAlignment === void 0 ? "end" : _param_flexAlignment, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var _displayMessages;
    var displayMessages = data.displayMessages;
    if (!((_displayMessages = displayMessages) === null || _displayMessages === void 0 ? void 0 : _displayMessages.length)) {
        return null;
    }
    return /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, {
        direction: "column",
        dataTestId: "price-summary"
    }, /* @__PURE__ */ React4.createElement("div", null, displayMessages.map(function(displayMessage, index) {
        return /* @__PURE__ */ React4.createElement(MessageLine, {
            key: "attr-".concat(index),
            index: index,
            flexAlignment: flexAlignment,
            displayMessage: displayMessage,
            enableInlineLink: enableInlineLink
        });
    })));
};
PriceSummary.fragment = fragment3;
PriceSummary.displayName = "PriceSummary";
MessageLine.displayName = "MessageLine";
export { PriceSummary };
//# sourceMappingURL=index.js.map